import { render, staticRenderFns } from "./GeoAssistance.vue?vue&type=template&id=55c9ee92"
import script from "./GeoAssistance.vue?vue&type=script&lang=js"
export * from "./GeoAssistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports